let ydConfig = {
    username: process.env.YD_CLOUD_USERNAME,
    password: process.env.YD_CLOUD_PASSWORD,
    ip: process.env.YD_CLOUD_IP,
    token: process.env.YD_CLOUD_TOKEN
};
// 初始化 App
let ydApp = ydCloud.initializeApp(ydConfig, 'myApp');
// 创建 Sync 对象
export const YDCLOUD = ydApp.sync();



// WEBPACK FOOTER //
// ./src/tool/ydCloudCommon.js